<div class="flex items-center justify-center min-h-screen w-full bg-base-200 p-4">
  <div class="card w-full max-w-md lg:max-w-2xl bg-base-100 shadow-xl card-enter">
    <div class="card-body items-center text-center">
      <i class="pi pi-check-circle text-success !text-6xl mb-4 icon-celebrate"></i>
      <p class="text-base-content/70 mb-6 text-enter">
        {{ 'LEAVE_APPLICATION.MESSAGE' | translate }}
      </p>
    </div>
  </div>
</div>
